"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperatingDateSeries = exports.isStandardDateFormatted = exports.toAgoString = exports.getRelativeDate = exports.getAsCachedFinancialDate = exports.sortDates = exports.getStringFromMoment = exports.hyphenatedMonthDay = exports.loadExtraMomentLocales = exports.getHivePartitionDateFolders = exports.zeroPadTime = exports.zeroPadHour = exports.findClosestTimeBlock = exports.getNearestTimeBlock = exports.getUTCOperatingBoundaryDatetimes = exports.getUTCStartOfOperatingDatetime = exports.getCompletedOperatingDate = exports.getActiveOperatingDate = exports.getOperatingDate = exports.DATETIME_MOMENT_FORMAT = void 0;
const financial_date_1 = require("./financial-date");
const moment_1 = require("moment");
const frequency_1 = require("./frequency");
exports.DATETIME_MOMENT_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS';
const MINIMUM_LOCAL_HOURS_AFTER_MIDNIGHT_TO_BE_BUSINESS_DAY = 12;
const DATE_MOMENT_FORMAT = 'YYYY-MM-DD';
function getOperatingDate(utcDatetime, utcOffset, utcEndOfDayHour, format, daysToOffset) {
    let utcM;
    if (typeof utcDatetime === 'string') {
        utcM = moment_1.utc(utcDatetime);
    }
    else {
        utcM = utcDatetime;
    }
    if (!format) {
        format = 'YYYY-MM-DD';
    }
    if (!daysToOffset) {
        daysToOffset = 0;
    }
    const startOfOperatingDatetime = getUTCStartOfOperatingDatetime(utcM, utcEndOfDayHour).add(daysToOffset, 'days');
    let closeOfOperatingDatetime = startOfOperatingDatetime.add(23, 'hours').add(59, 'minutes').utcOffset(utcOffset);
    if (closeOfOperatingDatetime.hour() < MINIMUM_LOCAL_HOURS_AFTER_MIDNIGHT_TO_BE_BUSINESS_DAY) {
        // We make an assumption here whether the EOD occurs in the same local "work day" or if it runs "early the next day".
        // We make that determination by counting the number of hours into the new local day (post midnight hours) and see if
        // that is beyond a certain threshold. The logic being you would not set your EOD as 5am locally and consider that 
        // 24 hours period (ending at that 5am point) to be named with the operating date of the 5am instead of -1 day of the
        // larger chunk of hours before.
        // This logic obviously breaks down if you do something silly like have your home base work day "start" at 1pm.
        closeOfOperatingDatetime = closeOfOperatingDatetime.subtract(1, 'day');
    }
    return closeOfOperatingDatetime.format(format);
    // let utc: Moment;
    // if (typeof utcDatetime === 'string') {
    //     utc = utc(utcDatetime);
    // } else {
    //     utc = utcDatetime;
    // }
    // if (!format) {
    //     format = 'YYYY-MM-DD';
    // }
    // const utcEOD = utc.clone().startOf('day').set('hour', utcEndOfDayHour);
    // const local = utc.clone().utcOffset(utcOffset);
    // const utcEODAsLocal = utcEOD.utcOffset(utcOffset);
    // const localEOD = local.clone().startOf('day').set('hour', utcEODAsLocal.hour()).set('minute', utcEODAsLocal.minute());
    // // Make sure we handle the case where cut off is defined as 00:00 Local (wherever that is UTC)
    // // We don't want to add 1 day just because any time today is > 00:00 today...(meaning cutoff was really 00:00 exclusive)
    // if (local.isSameOrAfter(localEOD) && (localEOD.hour() > 0 || (localEOD.hour() === 0 && localEOD.minute() > 0))) {
    //     return local.add(1, 'day').format(format);
    // } else {
    //     return local.format(format);
    // }
}
exports.getOperatingDate = getOperatingDate;
// Returns the actively transpiring operating date as of the call time
function getActiveOperatingDate(utcOffset, utcEndOfDayHour, format, daysToOffset) {
    return getOperatingDate(moment_1.utc(), utcOffset, utcEndOfDayHour, format, daysToOffset);
}
exports.getActiveOperatingDate = getActiveOperatingDate;
// Returns the last fully completed operating date
function getCompletedOperatingDate(utcOffset, utcEndOfDayHour, format) {
    return getOperatingDate(moment_1.utc(), utcOffset, utcEndOfDayHour, format, -1);
}
exports.getCompletedOperatingDate = getCompletedOperatingDate;
function getUTCStartOfOperatingDatetime(utcDatetime, utcEndOfDayHour) {
    let utc = utcDatetime.clone();
    const utcHour = utc.hour();
    if (utcHour < utcEndOfDayHour) {
        utc = utc.subtract(1, 'day');
    }
    return utc.startOf('day').add(utcEndOfDayHour, 'hours');
}
exports.getUTCStartOfOperatingDatetime = getUTCStartOfOperatingDatetime;
function getUTCOperatingBoundaryDatetimes(operatingDate, utcOffset, utcEndOfDayHour, format) {
    let startDatetime = moment_1.utc(operatingDate, 'YYYY-MM-DD').startOf('day').add(utcEndOfDayHour, 'hours').utcOffset(utcOffset);
    if (startDatetime.hour() < MINIMUM_LOCAL_HOURS_AFTER_MIDNIGHT_TO_BE_BUSINESS_DAY) {
        startDatetime = startDatetime.subtract(1, 'day');
    }
    const endDatetime = startDatetime.clone().add(1, 'day').subtract(1, 'minute');
    if (!format) {
        format = exports.DATETIME_MOMENT_FORMAT;
    }
    return [startDatetime.utc().format(format), endDatetime.utc().format(format)];
}
exports.getUTCOperatingBoundaryDatetimes = getUTCOperatingBoundaryDatetimes;
function getNearestTimeBlock(now, minuteBlockSize) {
    const hours = now.hours();
    const minutes = now.minutes();
    const numBlocks = Math.floor(minutes / minuteBlockSize);
    const blockMins = minuteBlockSize * numBlocks;
    return (hours * 100) + blockMins;
}
exports.getNearestTimeBlock = getNearestTimeBlock;
function findClosestTimeBlock(candidateBlocks, now, minuteBlockSize) {
    const hours = now.hours();
    const minutes = now.minutes();
    const nowBlock = (hours * 100) + minutes;
    const nowDayMinutes = hours * 60 + minutes;
    const diffs = candidateBlocks
        .map((blk) => {
        const h = Math.floor(blk / 100);
        const m = blk - (h * 100);
        const dm = h * 60 + m;
        const diff = Math.abs(nowDayMinutes - dm);
        return diff;
    });
    const minDiff = Math.min(...diffs);
    return candidateBlocks[diffs.indexOf(minDiff)];
}
exports.findClosestTimeBlock = findClosestTimeBlock;
function zeroPadHour(n) {
    let nStr = n + "";
    let padded = "00".substring(0, 2 - nStr.length) + nStr;
    return padded;
}
exports.zeroPadHour = zeroPadHour;
function zeroPadTime(n) {
    let nStr = n + "";
    let padded = "0000".substring(0, 4 - nStr.length) + nStr;
    return padded;
}
exports.zeroPadTime = zeroPadTime;
function getHivePartitionDateFolders(dateStr) {
    return moment_1.utc(dateStr, 'YYYY/MM/DD').format('[year=]YYYY/[month=]MM/[day=]DD');
}
exports.getHivePartitionDateFolders = getHivePartitionDateFolders;
function loadExtraMomentLocales(momentModule) {
    momentModule.locale('en-in', {
        parentLocale: 'en-gb'
    });
}
exports.loadExtraMomentLocales = loadExtraMomentLocales;
function hyphenatedMonthDay(m) {
    return m.format('L').substring(0, 5).replace('/', '-');
}
exports.hyphenatedMonthDay = hyphenatedMonthDay;
function getStringFromMoment(m, format) {
    if (!format) {
        format = DATE_MOMENT_FORMAT;
    }
    return m.format(format);
}
exports.getStringFromMoment = getStringFromMoment;
function sortDates(inputDates) {
    const outputDates = inputDates.sort((d1, d2) => {
        return (d1.getDateString() < d2.getDateString()) ? -1 : 1;
    });
    return outputDates;
}
exports.sortDates = sortDates;
function getAsCachedFinancialDate(cachingObject, date) {
    if (!cachingObject.financialDateCache) {
        cachingObject.financialDateCache = {};
    }
    let cachedDate = cachingObject.financialDateCache[date];
    if (!cachedDate) {
        cachedDate = financial_date_1.FinancialDate.fromString(date);
        cachingObject.financialDateCache[date] = cachedDate;
    }
    return cachedDate;
}
exports.getAsCachedFinancialDate = getAsCachedFinancialDate;
function getRelativeDate(referenceDate, relativeDateType) {
    let refFD;
    if (typeof referenceDate === 'string') {
        refFD = financial_date_1.FinancialDate.fromString(referenceDate);
    }
    else {
        refFD = referenceDate;
    }
    if (relativeDateType === 'PREVIOUS_DAY') {
        return refFD.addDays(-1);
    }
    else if (relativeDateType === 'START_OF_WEEK') {
        return refFD.firstDayOfWeek();
    }
    else if (relativeDateType === 'START_OF_MONTH') {
        return refFD.firstDayOfMonth();
    }
    else if (relativeDateType === 'END_OF_MONTH') {
        return refFD.lastDayOfMonth();
    }
    else if (relativeDateType === 'START_OF_QUARTER') {
        return refFD.firstDayOfQuarter();
    }
    else if (relativeDateType === 'END_OF_QUARTER') {
        return refFD.lastDayOfQuarter();
    }
    else if (relativeDateType === 'START_OF_YEAR') {
        return refFD.firstDayOfYear();
    }
    else if (relativeDateType === 'END_OF_YEAR') {
        return refFD.lastDayOfYear();
    }
    else if (relativeDateType === 'WEEK_ON_WEEK') {
        return refFD.addWeeks(-1);
    }
    else if (relativeDateType === 'MONTH_ON_MONTH') {
        return refFD.addMonths(-1);
    }
    else if (relativeDateType === 'PREVIOUS_END_OF_MONTH') {
        return refFD.addMonths(-1).lastDayOfMonth();
    }
    else if (relativeDateType === 'PREVIOUS_END_OF_QUARTER') {
        return refFD.firstDayOfQuarter().addDays(-1);
    }
    else if (relativeDateType === 'PREVIOUS_END_OF_YEAR') {
        return refFD.firstDayOfYear().addDays(-1);
    }
    else {
        return refFD;
    }
}
exports.getRelativeDate = getRelativeDate;
function toAgoString(dateTime, now) {
    const start = moment_1.utc(dateTime);
    if (!now) {
        now = moment_1.utc();
    }
    const dur = moment_1.duration(now.diff(start));
    const asMinutes = dur.asMinutes();
    const asHours = dur.asHours();
    const asDays = dur.asDays();
    let ago;
    if (asDays > 1.0) {
        ago = `${asDays.toFixed(1)} Days Ago`;
    }
    else if (asHours > 1.0) {
        ago = `${asHours.toFixed(1)} Hours Ago`;
    }
    else {
        ago = `${asMinutes.toFixed(1)} Min Ago`;
    }
    return ago;
}
exports.toAgoString = toAgoString;
function isStandardDateFormatted(str) {
    const dateRegex = /^\d{4}\-(0?[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
    return dateRegex.test(str);
}
exports.isStandardDateFormatted = isStandardDateFormatted;
function getOperatingDateSeries(operatingDate, numberOfPreviousDates, frequency, dayOfMonth) {
    if (frequency !== undefined && dayOfMonth !== undefined && numberOfPreviousDates > 0) {
        const series = [];
        series.push(operatingDate);
        for (let i = 0; i < numberOfPreviousDates; i++) {
            operatingDate = frequency_1.getLatestDateBeforeGivenDateRange(operatingDate, operatingDate, frequency, true, dayOfMonth);
            series.push(operatingDate);
        }
        return series;
    }
    else {
        return [operatingDate];
    }
}
exports.getOperatingDateSeries = getOperatingDateSeries;
//# sourceMappingURL=date-utils.js.map